import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import styles from "./acuant-camera-toolbar-container.less";

type AcuantCameraToolbarContainerProps = {
    onClickCloseCamera: () => void;
    onClickSwitchToNativeCamera: () => void;
};

export const AcuantCameraToolbarContainer = (props: AcuantCameraToolbarContainerProps) => {
    const { onClickCloseCamera, onClickSwitchToNativeCamera } = props;

    const content = useSelector(getLanguageContent);

    const handleClickCloseCamera = () => {
        onClickCloseCamera();
    };

    const handleClickSwitchToNativeCamera = () => {
        onClickSwitchToNativeCamera();
    };

    return (
        <div className={styles.acuantCameraToolbarContainer}>
            <Button className={styles.closeButton} onClick={handleClickCloseCamera}>
                {content.acuant.camera.closeText}
            </Button>
            <DropdownButton variant={"outline-secondary"} className={styles.dropdownButton} title={content.acuant.camera.optionsText}>
                <Dropdown.Item
                    key={`dropdown-menu-item-switch-to-native`}
                    as="button"
                    title={content.acuant.camera.useNativeCameraText}
                    onClick={handleClickSwitchToNativeCamera}
                >
                    <span className={styles.dropdownItemText}>
                        {content.acuant.camera.useNativeCameraText}
                    </span>
                </Dropdown.Item>
            </DropdownButton>
        </div>
    );
};